import { Fragment } from 'react';

import shareAccessHelp from '@/assets/share-access-help.png';

import styles from './PublicCollectionConfirmationContent.module.css';

export default function PublicCollectionConfirmationContent() {
  return (
    <Fragment>
      This collection contains products that have one of the next statuses: Restricted (products are not published and
      not available) or Unlisted (only via direct Widget or DiLog links). To configure access to these products use the
      Share Products Access button.
      <img
        alt="Share access help"
        width={497}
        height={255}
        className={styles.publicCollectionConfirmationContentImg}
        src={shareAccessHelp}
        loading="lazy"
      />
    </Fragment>
  );
}
